import { type ForwardRecipients, ForwardRecipientsSchema } from "./forward-contract.ts";

/**
 * The preset a reply opens with. Reply all preserves visible participants only; a received message
 * never reveals Bcc. The rep may change it (`InboxSendRequest.reply.recipients`).
 */
export function replyRecipients(
  message: { from: string; to: readonly string[]; cc: readonly string[] },
  mailbox: string,
  all: boolean,
): ForwardRecipients | null {
  const sender = mailbox.trim().toLowerCase();
  const lead = message.from.trim().toLowerCase();
  const seen = new Set([sender, lead]);
  const cc = all
    ? [...message.to, ...message.cc].flatMap((value) => {
        const address = value.trim().toLowerCase();
        if (seen.has(address)) return [];
        seen.add(address);
        return [address];
      })
    : [];
  const parsed = ForwardRecipientsSchema.safeParse({ to: [lead], cc, bcc: [] });
  return parsed.success ? parsed.data : null;
}

/**
 * Whether a reply's To, Cc or Bcc names the mailbox it is sent from. The preset never does, and a
 * set the rep typed may not either: the copy would land back in the mailbox's own inbox.
 */
export function addressesMailbox(recipients: ForwardRecipients, mailbox: string): boolean {
  const own = mailbox.trim().toLowerCase();
  return [...recipients.to, ...recipients.cc, ...recipients.bcc].some(
    (address) => address.trim().toLowerCase() === own,
  );
}
